import React, { Fragment } from "react"
import { Heading } from "../common/Heading"
import { about } from "../data/dummydata"

export const About = ({language, setLanguage}) => {
  return (
    <>
      <section className="about">
        <div className="flex">
          {about.map((val, i) => (
            <Fragment key={i}>
              <div className="left" data-aos="fade-down-right">
                <img src={val.cover} className="about-img" alt="" />
              </div>
              <div className="right" data-aos="fade-down-left">
                <Heading
                  title={language !== false ? "About me" : "Acerca de mi"}
                />
                <p>
                  {language !== false
                    ? "Full stack Developer with experience in web page design and development. Throughout my career, I have designed and developed various full-stack projects using tools such as HTML, CSS, Bootstrap, JavaScript, Typescript, Node.js, React, Next.js, Redux Toolkit Query, Express.js, Firebase, PostgreSQL, Sequelize, Material-UI, Git, and Trello. I am also familiar with project tracking tools like JIRA and Bitbucket, as well as agile methodologies like Scrum."
                    : "Desarrollador Full stack con experiencia en diseño y desarrollo de páginas web. A lo largo de mi carrera, he diseñado y desarrollado diversos proyectos full stack utilizando herramientas como HTML, CSS, Bootstrap, JavaScript, Typescript, Node.js, React, Next.js, Redux toolkit query, Express.js, Firebase, PostgreSQL, Sequelize, material-UI, GIT y Trello. También herramientas de seguimiento de proyectos como JIRA y Bitbucket, y metodologías ágiles como Scrum."}
                </p>

                {language !== false ? (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://drive.google.com/file/d/1Mu-YXWLWGETaffhLgXRsmD0V6qIZQGbp/view?usp=sharing"
                  >
                    <button className="right-btn"> Download CV</button>
                  </a>
                ) : (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://drive.google.com/file/d/1HaknF6Vcls_eJd60CIFi5g0rBVUF7tki/view?usp=sharing"
                  >
                    <button className="right-btn"> Descargar CV</button>
                  </a>
                )}
              </div>
            </Fragment>
          ))}
        </div>
      </section>
    </>
  );
}
